export function addCookie(name, value, expireHours) {
  let cookieString = name + '=' + escape(value)
    // 判断是否设置过期时间
  if (expireHours > 0) {
    let date = new Date()
    date.setTime(date.getTime() + expireHours * 3600 * 1000)
    cookieString = cookieString + ';expires=' + date.toGMTString() + ';path=/'
  }
  document.cookie = cookieString
}

export function getCookie(name) {
  let strCookie = document.cookie
  let arrCookie = strCookie.split(' ')
  for (let i = 0; i < arrCookie.length; i++) {
    let arr = arrCookie[i].split('=')
    if (arr[0] === name) return arr[1]
  }
  return ''
}

export function deleteCookie(name) {
  let date = new Date()
  date.setTime(date.getTime() - 10000)
  document.cookie = name + '=;expires=' + date.toGMTString() + ';path=/'
}



// WEBPACK FOOTER //
// ./src/common/js/cookies.js